// extracted by mini-css-extract-plugin
export var button = "_hs-0";
export var donut = "_hs-1";
export var donutFill = "_hs-3";
export var donutTrack = "_hs-2";